module.exports = {
  aboutMe: {
    childMarkdownRemark: {
      rawMarkdownBody:
        " My name is Marcel and I'm a young software developer. \n \n At the moment I am studying Applied Computer Science at the [HTW Berlin](https://www.htw-berlin.de/) and working as a working student for [SatoshiPay](https://satoshipay.io/). My interests lie in the fields of Internet of Things and Blockchain Technologies. I enjoy creating mobile applications especially because of their broad and extensive availability. \n \nI have sophisticated knowledge in \n - the Java- and Kotlin Programming languages and \n - Android-Development. \n \nI have not completely mastered yet but am proficient at \n - iOS-Development with Swift and \n - JavaScript and React Development.",
    },
  },
  profile: {
    title: 'Photo by Caspar Camille Rubin on Unsplash',
    image: {
      src: 'https://source.unsplash.com/89xuP-XmyrA',
    },
  },
};
